// extracted by mini-css-extract-plugin
module.exports = {"Logo__root":"Zk6Y"};